// Mirrored from mju-ai-workbench/shared/wording/remoteWords.ts (f8078e9f, D282) — keep the two identical but for this line.
/**
 * Remote control's words (D282): plain constants and functions, no imports, so the renderer reads
 * them as well as the host. The contract's shapes are in shared/schemas/remoteControl.ts.
 */
/** The words each status shows. */
export const LIVE_STATUS_WORDS = {
    thinking: "Thinking",
    waiting: "Waiting for you",
    done: "Done",
    stopped: "Stopped",
    idle: "Ready for your next message",
};
/** "JP's phone", "JP in a browser": who controls a session, in the banner's words. */
export function controllerWords(name, via) {
    const who = name.trim() || "Someone";
    return via === "phone" ? `${who}'s phone` : `${who} in a browser`;
}
//# sourceMappingURL=remoteWords.js.map